import HotWorkCategoryThreeOptions from "../../../permits/EnergyHarbourPermit/HotWorkCategoryThreeOptions";
import FormElement, { formElement } from "../../FormElement";

type HotWorkCategoryThreeOptionsFormState = {
    vacuumTruck: FormElement<boolean>;
    excavator: FormElement<boolean>;
    craneTruck: FormElement<boolean>;
    generator: FormElement<boolean>;
    boat: FormElement<boolean>;
    drone: FormElement<boolean>;
    openExClassifiedEquipment: FormElement<boolean>;
    multimeter: FormElement<boolean>;
    nonExCamera: FormElement<boolean>;
    GPS: FormElement<boolean>;
    other: FormElement<string>;
};

export default HotWorkCategoryThreeOptionsFormState;

export function HotWorkCategoryThreeOptionsFormState_default(): HotWorkCategoryThreeOptionsFormState {
    return {
        boat: formElement(false),
        craneTruck: formElement(false),
        drone: formElement(false),
        excavator: formElement(false),
        generator: formElement(false),
        GPS: formElement(false),
        multimeter: formElement(false),
        nonExCamera: formElement(false),
        openExClassifiedEquipment: formElement(false),
        other: formElement(""),
        vacuumTruck: formElement(false)
    };
}

export function HotWorkCategoryThreeOptionsFormState_fromFormState(
    formState: HotWorkCategoryThreeOptionsFormState
): HotWorkCategoryThreeOptions {
    return {
        boat: formState.boat.value,
        craneTruck: formState.craneTruck.value,
        drone: formState.drone.value,
        excavator: formState.excavator.value,
        generator: formState.generator.value,
        GPS: formState.GPS.value,
        multimeter: formState.multimeter.value,
        nonExCamera: formState.nonExCamera.value,
        openExClassifiedEquipment: formState.openExClassifiedEquipment.value,
        other: formState.other.value,
        vacuumTruck: formState.vacuumTruck.value
    };
}
